import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./FilterFeatureVideoLesson.module.scss";
import {useFilterFeatureVideoLessonLogic} from "./FilterFeatureVideoLesson.logic";
import {RadioButtonFilterGroup} from "../../filters/radio-button-filter-group/RadioButtonFilterGroup";
import {
  MySongsPageFilterLessonFeatureType
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.types";

export const FilterFeatureVideoLesson: VoidFunctionComponent = () => {
  const {value, onChangeHandler} = useFilterFeatureVideoLessonLogic();
  return (
    <div className={s.container}>
      <p className={s.groupLabel}>Features</p>
      <RadioButtonFilterGroup<MySongsPageFilterLessonFeatureType>
        value={value}
        onChange={onChangeHandler}
        options={[
          {
            label: `All Features`,
            value: `all`,
          },
          {
            label: `Includes Video`,
            value: `lesson.hasVideo`,
          },
        ]}
      />
    </div>
  );
}
